import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Nav from "./components/Header/Nav.jsx";
import Footer from "./components/Footer/Footer.jsx";
import StartOrderPage from "./pages/StartOrder/StartOrderPage.jsx";
import GetPDFPage from "./pages/GetPDF/GetPDFPage.jsx";
import ErrorPage from "./pages/Error/ErrorPage.jsx";

const App = () => {
  return (
    <Router basename="/">
      <Nav />
      <main>
        <Routes>
          <Route path="/:objectId" element={<StartOrderPage />} />
          <Route path="/download/:orderId" element={<GetPDFPage />} />
          <Route path="/error" element={<ErrorPage />} />

          {/* Fallback for unmatched routes */}
          <Route
            path="*"
            element={<Navigate to="/error" state={{ message: "Leider wurde diese Seite nicht gefunden.", status: "404" }} />}
          />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
};

export default App;
